import { render } from "./localeDropdown.vue?vue&type=template&id=1eba70dd&scoped=true"
import script from "./localeDropdown.vue?vue&type=script&lang=js"
export * from "./localeDropdown.vue?vue&type=script&lang=js"

import "./localeDropdown.vue?vue&type=style&index=0&id=1eba70dd&lang=scss&scoped=true"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eba70dd"]])

export default __exports__